import styled from '@emotion/styled';
import { StyledProps } from './TableContainer.types';

export const StyledTable = styled.table<StyledProps>`
  width: ${(props) => props.width || '100%'};
  justifycontent: space-evenly;
  alignitems: center;
  border-collapse: collapse;
  border: 1px var(--color-smoke-30);
  border-style: solid;
  margin: 0px auto;
  margin-bottom: 30px;
  overflow-x: scroll;
  line-height: 20px;
  font-family: var(--secondary-font);
  table-layout: ${(props) => props.rowWidthEqual && 'fixed'};
`;

export const Caption = styled.caption`
  text-align: start;
  padding-bottom: 30px;
  font-weight: bold;
  font-size: var(--text-md);
`;
